import "react-datepicker/dist/react-datepicker.css";
import { Toaster } from "react-hot-toast";
import { io } from "socket.io-client";
import Application from "./Application";
import Loader from "./components/common/Loader/Loader";
import { useSocketService } from "./Services/socket.hooks.service";
import { SOCKET_URL } from "./utils/constants";

export const socket = io(SOCKET_URL, {
  reconnection: true,
  reconnectionDelay: 1000,
  reconnectionAttempts: 9999,
  transports: ["websocket"],
});

function App() {

  const socketHook = useSocketService();

  return (
    <>
      <Loader />
      <Toaster />
      <Application />
    </>
  );
}

export default App;
